import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { QuestionSchema } from '../types/questionsSchema';
import { GetQuestion } from '../services/GetQuestion';
import { HYDRATE } from 'next-redux-wrapper';

const initialState: QuestionSchema = {
  questionList: [],
  isLoaded: false,
  activeQuestion: null,
};

export const questionsSlice = createSlice({
  name: 'questionsSlice',
  initialState,
  reducers: {
    setActiveQuestion: (state, action: PayloadAction<number>) => {
      state.activeQuestion = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.questionsSlice,
      };
    });
    builder.addCase(GetQuestion.fulfilled, (state, action) => {
      if (action.payload) {
        state.questionList = action.payload;
      }
      state.isLoaded = true;
    });
  },
});

export const { actions: questionsActions } = questionsSlice;
